import { Box } from '@betterment/samba-react';

interface LoaderProps {
  isLoading: boolean;
  title?: string;
  children?: React.JSX.Element | React.JSX.Element[] | null;
  className?: string;
}

export default function Loader({ isLoading, title = 'Loading', children, className }: LoaderProps) {
  return (
    <Box
      style={{ position: 'relative' }}
      css={{
        width: '100%',
      }}
    >
      {isLoading && (
        <div className={`${className || ''} LoadingSpinner-background`}>
          <svg className="LoadingSpinner-svg" viewBox="0 0 64 64">
            <title>{title}</title>
            <circle className="LoadingSpinner-path" cx="32" cy="32" r="20" />
            <circle className="LoadingSpinner-spinner" cx="32" cy="32" r="20" />
          </svg>
        </div>
      )}
      {children}
    </Box>
  );
}
